import { Injectable, inject } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UnsavedChangesDialogComponent } from './unsaved-changes-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class AreYouSureGuard {
  #dialog = inject(MatDialog);

  canDeactivate(component: {
    dirty?: boolean;
  }): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // If the calling component has not implemented dirty, or dirty is false, do nothing
    if (!component?.dirty) {
      return true;
    }

    // Dirty must be true on the calling component
    const dialogRef = this.#dialog.open(UnsavedChangesDialogComponent, {
      width: '80vw',
      maxWidth: '600px',
      minWidth: '300px',
      disableClose: true,
      panelClass: 'unsaved-changes-dialog',
    });

    return dialogRef.afterClosed().pipe(map((result) => !!result));
  }
}
